/* SPDX-License-Identifier: Apache-2.0 */
import {ThemeComponent} from '@geogirafe/lib-geoportal/components';
import {CustomTheme, ThemeLayer} from '@geogirafe/lib-geoportal/models';

interface CommuneLink {
  label: string;
  url: string;
  icon?: string;
}

class SitnThemeComponent extends ThemeComponent {
  override templateUrl = './template.html';
  override styleUrls = [
    '../../../node_modules/@geogirafe/lib-geoportal/components/themes/style.css',
    '../../../node_modules/@geogirafe/lib-geoportal/styles/common.css',
    './style.css',
  ];

  override activeThemeType: any = 'all';

  get favoritesAndCustomThemes(): (ThemeLayer | CustomTheme)[] {
    const favorites = this.favoriteThemes;
    const favoriteIds = new Set(favorites.map((t) => t.id));
    const nonFavoriteCustom = Object.values(this.customThemes).filter((t) => !favoriteIds.has(t.id));
    return [...favorites, ...nonFavoriteCustom];
  }

  get communeLinks(): CommuneLink[] {
    const extConfig = this.context.configManager.Config.extendedConfig as any;
    return extConfig?.['themes']?.communes ?? [];
  }

  get cantonalInterfaceUrl(): string | undefined {
    const extConfig = this.context.configManager.Config.extendedConfig as any;
    return extConfig?.['themes']?.cantonalInterfaceUrl;
  }

  override activateThemeType(themeType: string): void {
    this.activeThemeType = themeType;
    this.render();
  }

  override isThemeTypeActive(themeType: string): boolean {
    return (this.activeThemeType ?? 'all') === themeType;
  }

  goToCantonalGeoportal() {
    window.location.href = this.cantonalInterfaceUrl ?? '/';
  }
}

export default SitnThemeComponent;
